export default __webpack_public_path__ + "static/dylan-9260075399d2184e4b945a285e611c15.jpg";